module.exports = __webpack_public_path__ + "static/media/jobs-hero.431e75ca.jpg";